






















































































import { Observer } from 'mobx-vue'
import { Component, Inject, Vue } from 'vue-property-decorator'
import { FarmingViewModel } from '@/modules/sb-farm/viewmodels/farming-viewmodel'

@Observer
@Component({
  components: {
    'multi-logo': () => import('@/components/multi-logo/multi-logo.vue')
  }
})
export default class extends Vue {
  @Inject() vm!: FarmingViewModel
}
